import React from 'react';
import SectionTitle from '../components/ui/SectionTitle';

const Impressum: React.FC = () => {
  return (
    <div className="pt-32 pb-20">
      <div className="container-custom">
        <SectionTitle title="Impressum" />
        
        <div className="prose max-w-none">
          <h2 className="text-2xl font-semibold mb-4">Angaben gemäß § 5 Telemedien-Digitale-Dienste-Gesetz (TDDDG)</h2>
          <p className="mb-6">
            Monica Meier<br />
            Starnberger Str. 24<br />
            82131 Gauting<br />
            Festnetz: +49 89 90157634<br />
            Mobil: +49 171 1144557<br />
            E-Mail: m.meier@vorsorgewerk24.de<br />
            Internet: www.vorsorgewerk24.de
          </p>

          <h2 className="text-2xl font-semibold mb-4">Berufsrechtliche Angaben</h2>
          <p className="mb-4">
            Ich bin als selbstständige Handelsvertreterin gemäß § 84 HGB tätig.
          </p>
          <p className="mb-4">
            Die Vermittlung von Versicherungs- und Energieleistungen erfolgt ausschließlich im Namen und auf Rechnung der folgenden Kooperationspartner:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li>A&K Vorsorgespezialisten UG, Sonnenhang 10A, 51381 Leverkusen (Versicherungsvermittlung, registriert nach § 34d GewO)</li>
            <li>4Motion GmbH, Rosa-Luxemburg-Str. 19/21, 04103 Leipzig (Energievermittlung, Strom und Gas)</li>
          </ul>
          <p className="mb-4">
            Makler- bzw. Vermittlungsverträge kommen ausschließlich zwischen dem Kunden und dem jeweiligen Kooperationspartner zustande.
          </p>
          <p className="mb-4">
            Ich selbst verfüge über keine eigene Erlaubnis gemäß § 34d GewO.
          </p>
          <p className="mb-6">
            Die rechtliche Verantwortung für die Vermittlungstätigkeit liegt ausschließlich bei den jeweiligen Partnerunternehmen.
          </p>

          <h2 className="text-2xl font-semibold mb-4">Haftung für Inhalte</h2>
          <p className="mb-6">
            Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehme ich keine Gewähr. Als Diensteanbieterin bin ich gemäß § 7 Abs. 1 TDDDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
          </p>

          <h2 className="text-2xl font-semibold mb-4">Hinweis zu Formularen & Datenerhebung</h2>
          <p className="mb-4">
            Wenn Sie über diese Website personenbezogene Daten übermitteln (z. B. per Kontaktformular oder Checkliste), erfolgt die Erhebung ausschließlich im Auftrag und zur Weiterleitung an den zuständigen Kooperationspartner mit entsprechender Erlaubnis nach § 34d GewO.
          </p>
          <p className="mb-6">
            Ich verarbeite Ihre Angaben nicht für eigene Zwecke, sondern lediglich als Vermittlungshelferin im Rahmen meiner Tätigkeit als Handelsvertreterin.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;